import {EnvNoticePostDataTransferObject} from "../../data-transfer-object/env/EnvNoticePostDataTransferObject"

/**
 * 공지사항 속성 설명
 */
export const EnvNoticePostDataTransferObjectDescription: Record<keyof EnvNoticePostDataTransferObject, string> = {
    title: '제목',
    url: 'URL'
}
